import React from 'react';

export const AdditionalInfo = () =>
  <p>
    Results from randomized control trials were used to inform estimates for the likelihood of receiving an
    angioplasty . The overall rating of the strength of evidence for this outcome is “moderate” (meaning
    the true effect is probably close to the estimated effect). The certainty of this evidence was affected
    by imprecision (wide range of plausible estimates around the best estimate of the effect).
  </p>;
